import { DocumentTemplate } from './DocumentTemplate';

export class DocumentTemplateMatch {
  templates: DocumentTemplate[] = [];
  matchedTemplateId?: number;

  constructor(opts?: Partial<DocumentTemplateMatch>) {
    if (opts?.templates != null) {
      this.templates = opts.templates.map((val) => new DocumentTemplate(val));
    }
    this.matchedTemplateId = opts?.matchedTemplateId;
  }
}
